import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { authApi } from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user

  useEffect(() => {
    // OAuth callback: exchange session_id FIRST, before any /me check (avoids race condition)
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      if (sid) {
        authApi
          .googleSession(sid)
          .then((u) => {
            // clear the fragment so it isn't re-processed on refresh
            window.history.replaceState(null, "", window.location.pathname + window.location.search);
            setUser(u);
          })
          .catch(() => {
            window.history.replaceState(null, "", window.location.pathname + window.location.search);
            toast.error("La connexion Google a échoué. Veuillez réessayer.");
            setUser(false);
          });
        return;
      }
    }
    // Normal check — works via Emergent session cookie OR JWT bearer (localStorage)
    authApi
      .me()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("editorix_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const data = await authApi.login({ email, password });
    localStorage.setItem("editorix_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (email, password, name) => {
    const data = await authApi.register({ email, password, name });
    localStorage.setItem("editorix_token", data.token);
    setUser(data);
    return data;
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const loginWithGoogle = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await authApi.logout(); } catch (e) {}
    localStorage.removeItem("editorix_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, loginWithGoogle, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
